<soft-op-diagram-tabelle-view
  [offenePosten]="offenePosten()"
  [loading]="loading()"
  [invertValues]="true"
  [showExtraColumn]="true"
  [color]="'var(--colorDanger600)'"
  [title]="'#OFFENE_POSTEN.KREDITOREN_TITLE'"
  [subtitle]="'#OFFENE_POSTEN.KREDITOREN_SUB_TITLE'">
</soft-op-diagram-tabelle-view>
